import React from 'react';
import { createUseStyles } from 'react-jss';
import Spin from 'react-spinkit';

const spinnerProps = {
  name: 'ball-grid-pulse',
  fadeIn: 'none'
};

const useStyles = createUseStyles({
  loader: {
    position: 'fixed',
    backgroundColor: 'white',
    opacity: 0.8,
    zIndex: 1,
    width: '100%',
    height: '100%'
  }
});

const Spinner = props => {
  const classes = useStyles();
  return (
    <div className={`loaderHolder ${classes.loader}`}>
      <Spin {...spinnerProps} />
    </div>
  );
};

export default Spinner;
